import template from './commercial-name.jade';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.commercialName', []).directive('cianAfAboutObjectCommercialName', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.validation = validation(this.form, 'name', {
      required: 'Укажите наименование объекта',
    });
  },
  controllerAs: 'commercialName',
  template,
})).name;
